import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="47.91 27.07 47.91 47.91 24.8 47.91 16.48 36.31 33.76 11.78 47.91 27.07"
  />
);

const AvatarArtworkZero = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_9}
    renderShadow={renderShadow}
  >
    <g transform="translate(0 -1.5)">
      <path
        d="M32.82,29.88a12.17,12.17,0,0,1-.65,4.66,10.36,10.36,0,0,1-2.58,4L26.27,40.8a4.5,4.5,0,0,1-5.17,0l-3.36-2.31a10.36,10.36,0,0,1-2.58-4,12.17,12.17,0,0,1-.65-4.66l.66-17.45h17Z"
        style={{ fill: '#c28d7e' }}
      />
      <path
        d="M20.43,36.93c-.21.32.27.66.95.83a10.32,10.32,0,0,0,2.28.19,10.51,10.51,0,0,0,2.15-.18c.65-.15,1.16-.44,1.09-.75a.15.15,0,0,0-.07-.1,1.09,1.09,0,0,0-.34-.06c-1.6-.12-3.23-.17-4.85-.16a5.49,5.49,0,0,0-1.1.1"
        style={{ fill: '#8e625d' }}
      />
      <path
        d="M20.38,36.89a4.19,4.19,0,0,1,3.2-1.1,4.26,4.26,0,0,1,3.24,1.07s0,.06,0,.08a.18.18,0,0,1-.11,0c-.93.05-1.8-.22-3-.22a33,33,0,0,0-3.39.25Z"
        style={{ fill: '#77524f' }}
      />
      <path
        d="M15.54,27.92s-1.76-5.49,1.57-8.16c3.48-2.8,10.24-.27,10.24-.27H13.69s1.23.68,0,1.92a2.55,2.55,0,0,1-2.48.85l.53,1.2-1,.24.84.72c.21.19-.51.57-.31.77a12.85,12.85,0,0,1,2.12,2.73Z"
        style={{ fill: '#352c2c' }}
      />
      <path
        d="M15.54,28.19H13.37a.28.28,0,0,1-.23-.13,12.53,12.53,0,0,0-2.08-2.67c-.28-.28,0-.61.15-.77l.07-.08-.73-.63a.28.28,0,0,1-.09-.27.26.26,0,0,1,.2-.2l.7-.17-.39-.9A.26.26,0,0,1,11.3,22a2.3,2.3,0,0,0,2.2-.78,1.25,1.25,0,0,0,.46-.95.89.89,0,0,0-.4-.56.27.27,0,0,1-.13-.3.28.28,0,0,1,.26-.21H17.4c3.64-2.32,9.78-.08,10.05,0a.27.27,0,0,1-.1.53H17.56a2.55,2.55,0,0,0-.28.21c-3.14,2.52-1.5,7.82-1.48,7.87a.26.26,0,0,1,0,.24A.27.27,0,0,1,15.54,28.19Zm-2-.54h1.65c-.32-1.25-1.17-5.46,1.51-7.89H14.34a1.37,1.37,0,0,1,.16.43,1.72,1.72,0,0,1-.61,1.41,3.06,3.06,0,0,1-2.23,1l.33.75a.27.27,0,0,1,0,.23.26.26,0,0,1-.18.14l-.5.12.43.37c.32.28,0,.63-.12.78l-.09.09A13.1,13.1,0,0,1,13.53,27.65Zm5.07-8.44h6.86C23.64,18.78,20.8,18.35,18.6,19.21Z"
        style={{ fill: '#3d3231' }}
      />
      <path
        d="M31.87,27.89s1.76-5.49-1.57-8.16-10.24-.28-10.24-.28,12.44.69,13.66,1.93a2.55,2.55,0,0,0,2.48.85l-.53,1.2,1,.24-.83.72c-.22.19.5.57.3.77A13.18,13.18,0,0,0,34,27.89Z"
        style={{ fill: '#352c2c' }}
      />
      <path
        d="M34,28.16H31.87a.27.27,0,0,1-.26-.35s1.34-4.3-.64-7a109,109,0,0,0-10.92-1.09.27.27,0,0,1-.26-.23A.27.27,0,0,1,20,19.2c.28-.11,7-2.54,10.5.31a5.22,5.22,0,0,1,.81.82,6.24,6.24,0,0,1,2.64.86,2.24,2.24,0,0,0,2.2.78.29.29,0,0,1,.28.08.28.28,0,0,1,.05.29l-.4.9.71.17a.29.29,0,0,1,.2.2.28.28,0,0,1-.09.27l-.74.63.08.08c.14.16.43.48.14.77A12.6,12.6,0,0,0,34.27,28,.28.28,0,0,1,34,28.16Zm-1.81-.54h1.66a13.14,13.14,0,0,1,2-2.57L35.8,25c-.13-.14-.43-.49-.12-.76l.43-.38-.5-.12a.28.28,0,0,1-.18-.14.27.27,0,0,1,0-.23l.34-.75a3.06,3.06,0,0,1-2.23-1A4.55,4.55,0,0,0,31.72,21C33.15,23.38,32.51,26.56,32.23,27.62ZM21.58,19.28c2.15.14,6,.43,8.82.89a2,2,0,0,0-.27-.23C27.77,18,23.73,18.72,21.58,19.28Z"
        style={{ fill: '#3d3231' }}
      />
      <path
        d="M15.05,29.41c-.13.45-.33.88-.44,1.34a1.31,1.31,0,0,1-.38.8,1.33,1.33,0,0,1-1.34-.24c-.7-.52-.75-1.35-1-2a4.23,4.23,0,0,1-.31-2.45c.12-.47.24-1.44.9-1.66,1.05-.35,1.88.86,2.26,1.69A3.89,3.89,0,0,1,15.05,29.41Z"
        style={{ fill: '#c28d7e' }}
      />
      <path
        d="M32.14,29.41c.14.45.33.88.44,1.34a1.31,1.31,0,0,0,.38.8,1.33,1.33,0,0,0,1.34-.24,3.49,3.49,0,0,0,1-2,4.23,4.23,0,0,0,.31-2.45c-.12-.47-.24-1.44-.9-1.66-1-.35-1.88.86-2.26,1.69A4,4,0,0,0,32.14,29.41Z"
        style={{ fill: '#c28d7e' }}
      />
      <path
        d="M33.85,11.86v9.68c-1.43-.51-5.48-.87-10.26-.87s-8.8.36-10.24.86a0,0,0,0,1,0,0V11.86a.47.47,0,0,1,.39-.42,43.53,43.53,0,0,1,19.73,0A.46.46,0,0,1,33.85,11.86Z"
        style={{ fill: '#639' }}
      />
      <ellipse
        cx="23.51"
        cy="11.63"
        rx="9.73"
        ry="1.14"
        style={{ fill: '#783bad' }}
      />
      <path
        d="M23.59,10.57c5.38,0,9.74.51,9.74,1.14S29,12.85,23.59,12.85s-9.73-.51-9.73-1.14,4.36-1.14,9.73-1.14m0-.46a62.28,62.28,0,0,0-6.94.34c-2.75.32-3.3.72-3.3,1.26s.55.95,3.3,1.27a62.28,62.28,0,0,0,6.94.34,62.34,62.34,0,0,0,7-.34c2.75-.32,3.3-.72,3.3-1.27s-.55-.94-3.3-1.26a62.34,62.34,0,0,0-6.95-.34Z"
        style={{ fill: '#639' }}
      />
      <path
        d="M26.84,35.4h-.09a16,16,0,0,0-6.21,0,.32.32,0,0,1-.4-.2.3.3,0,0,1,.18-.39h0a16.94,16.94,0,0,1,6.58,0,.31.31,0,0,1-.09.61Z"
        style={{ fill: '#3d3231' }}
      />
    </g>
  </AvatarArtwork>
);

export default AvatarArtworkZero;
